/* ESSENTIRA — Combo de producto con descuento por cantidad */
(function () {
  'use strict';
  function arr(l) { return Array.prototype.slice.call(l); }

  function money(cents) {
    var f = (window.Shopify && window.Shopify.moneyFormat) ? window.Shopify.moneyFormat : '${{amount}}';
    var v = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    return f.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function init(root) {
    if (!root || root.getAttribute('data-bundle-ready')) return;
    root.setAttribute('data-bundle-ready', '1');

    var tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]') || []; } catch (e) { tiers = []; }
    tiers = tiers.filter(function (t) { return t && t.qty > 0 && t.pct > 0; })
                 .sort(function (a, b) { return a.qty - b.qty; });

    var totalEl = root.querySelector('[data-bundle-total]');
    var wasEl = root.querySelector('[data-bundle-was]');
    var saveEl = root.querySelector('[data-bundle-save]');
    var nudgeEl = root.querySelector('[data-bundle-nudge]');
    var cta = root.querySelector('[data-bundle-add]');
    var tierEls = arr(root.querySelectorAll('[data-tier-qty]'));

    function items() { return arr(root.querySelectorAll('[data-bundle-item]')); }
    function chosen() { return items().filter(function (i) { return i.checked; }); }

    /* El escalon que aplica es el de mayor cantidad que el carrito alcanza. */
    function tierFor(n) {
      var best = null;
      tiers.forEach(function (t) { if (n >= t.qty) best = t; });
      return best;
    }
    function nextTier(n) {
      for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > n) return tiers[i]; }
      return null;
    }

    var activeCode = '';

    function refresh() {
      var picked = chosen();
      var n = picked.length;
      var sum = picked.reduce(function (a, i) {
        return a + (parseInt(i.getAttribute('data-price'), 10) || 0);
      }, 0);

      var tier = tierFor(n);
      var pct = tier ? tier.pct : 0;
      activeCode = tier && tier.code ? tier.code : '';
      var final = pct > 0 ? Math.round(sum * (100 - pct) / 100) : sum;

      if (totalEl) totalEl.textContent = money(final);
      if (wasEl) {
        if (sum > final) { wasEl.textContent = money(sum); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (saveEl) {
        if (sum > final) { saveEl.textContent = 'Ahorras ' + money(sum - final) + ' (' + pct + '%)'; saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }

      tierEls.forEach(function (el) {
        var q = parseInt(el.getAttribute('data-tier-qty'), 10);
        if (tier && q === tier.qty) { el.classList.add('is-active'); }
        else { el.classList.remove('is-active'); }
      });

      if (nudgeEl) {
        var nxt = nextTier(n);
        var reachable = nxt && nxt.qty <= items().length;
        if (reachable) {
          var falta = nxt.qty - n;
          nudgeEl.textContent = 'Agrega ' + falta + (falta === 1 ? ' producto más' : ' productos más') +
            ' y llévate ' + nxt.pct + '% de descuento.';
          nudgeEl.hidden = false;
        } else { nudgeEl.hidden = true; }
      }

      if (cta) {
        cta.disabled = n < 2;
        cta.textContent = n < 2 ? 'ELIGE AL MENOS 2' : 'AGREGAR LOS ' + n + ' A LA BOLSA';
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bundle-item')) refresh();
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var list = chosen().map(function (i) {
          return { id: parseInt(i.getAttribute('data-id'), 10), quantity: 1 };
        });
        if (list.length < 2) return;
        var code = activeCode;
        cta.disabled = true;
        cta.textContent = 'AGREGANDO…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            /* Con codigo: /discount/CODE lo aplica de verdad y devuelve al carrito.
               Sin codigo: abrimos el cajon del carrito sin salir de la pagina. */
            if (code) {
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
              return;
            }
            var opener = document.querySelector('[data-cart-open]');
            if (opener) { opener.click(); } else { window.location.href = '/cart'; }
            refresh();
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    }

    refresh();
  }

  function boot(scope) { arr((scope || document).querySelectorAll('[data-bundle]')).forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
